import { WALLET_PROVIDERS } from '@/config/profile'
import { useWalletProviders } from '@/hooks/use-wallet-providers'
import { cn } from '@/lib/utils'
import { Button } from '../ui/button'

export function WalletProviderList() {
	const { getProviderState, linkProvider } = useWalletProviders()

	return (
		<div className='overflow-hidden rounded-xl border border-border'>
			{WALLET_PROVIDERS.map((provider, index) => {
				const { isConnected, isConnecting } = getProviderState(provider.id)
				const isLinkable = provider.id === 'metamask' || provider.id === 'phantom'

				return (
					<div
						key={provider.id}
						className={index > 0 ? 'flex items-center justify-between gap-3 border-t border-border px-4 py-4' : 'flex items-center justify-between gap-3 px-4 py-4'}
					>
						<div className='flex items-center gap-3'>
							<span className='flex h-10 w-10 items-center justify-center rounded-full text-xs font-bold text-background' aria-hidden>
								<img src={provider.iconUrl} alt={provider.name} className='h-10 w-10' />
							</span>
							<span className='text-sm font-semibold tracking-[-0.21px] text-foreground'>{provider.name}</span>
						</div>
						<Button
							variant='secondary'
							onClick={() => {
								void linkProvider(provider.id)
							}}
							disabled={!isLinkable || isConnected || isConnecting}
						>
							{isConnected ? 'Connected' : 'Link'}
						</Button>
					</div>
				)
			})}
		</div>
	)
}
